import _objectSpread from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import _objectWithoutProperties from "/Users/fangyu/Code/unifygama/metacrm/metadesk-frontend/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties.js";
const _excluded = ["className"];
import { memo, forwardRef } from 'react';
import { jsx } from 'react/jsx-runtime';
import { useBEM } from '../hooks/useBEM.js';
import { roleNone, menuClass, menuHeaderClass } from '../utils/constants.js';
import { stylePropTypes } from '../utils/propTypes.js';
const MenuHeader = /*#__PURE__*/memo(/*#__PURE__*/forwardRef(function MenuHeader(_ref, externalRef) {
  let {
      className
    } = _ref,
    restProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/jsx("li", _objectSpread(_objectSpread({
    role: roleNone
  }, restProps), {}, {
    ref: externalRef,
    className: useBEM({
      block: menuClass,
      element: menuHeaderClass,
      className
    })
  }));
}));
process.env.NODE_ENV !== "production" ? MenuHeader.propTypes = _objectSpread({}, stylePropTypes()) : void 0;
export { MenuHeader };